import { EXPIRED_BANNER_COPY } from "./pricingContent";
import { SubscriptionStatusBanner } from "./SubscriptionStatusBanner";

export const ExpiredSubscriptionBanner = () => (
  <SubscriptionStatusBanner label={EXPIRED_BANNER_COPY.message} />
);
